var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_c('div',{staticClass:"collection-card"},[_vm._v(" "+_vm._s(_vm.data)+" ")]),_c('div',{staticClass:"finish-area"},[_c('v-btn',{staticClass:"understand-btn",on:{"click":function($event){return _vm.$emit('closeDialog')}}},[_vm._v(" Понятно ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }